import PageContainer from '@/common/components/PageContainer'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetRank from '@/modules/manage-rank/api/hooks/useQueryGetRank'
import RankListing from '@/modules/manage-rank/components/Rank/components/RankListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function RankPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		name: searchQuery,
	}

	const { data, isLoading } = useQueryGetRank(payload)

	return (
		<PageContainer>
			<RankListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedRankPage = withUserPermission(RankPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_RANK],
})

export default GuardedRankPage
